module.exports = __webpack_public_path__ + "img/4ab896c.jpg";